import {APIResource, APIError} from '@/utils/APIResources';
import {AxiosError} from 'axios';
import {
    V1ConfigApiAxiosParamCreator
} from 'shift-config-service-api-client';
import {PolicyPartyModel} from 'shift-policy-service-api-client';

const service = V1ConfigApiAxiosParamCreator();

export default class {
    public static async getConfigValuesByNamespaceAndPath(namespace: string, path: string): Promise<any | null> {
        const req = await service.getConfigValuesByNamespaceAndPath(namespace, path);
        return APIResource.get(req.url, req.options)
            .then((response) => {
                return response.data ? response.data : null;
            })
            .catch((error: AxiosError) => {
                return Promise.reject(new APIError(error));
            });
    }
}
